<template>
  <!-- 平台方 -->
  <div class="statistics">
    <!-- 数据累计 -->
    <div class="cumulative-ul" v-if="statistics">
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text1") }}</span>
          <span>
            <countTo
              :startVal="0"
              :endVal="statistics.bikeTotal ? statistics.bikeTotal : 0"
              :duration="3000"
            ></countTo>
          </span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon1.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text2") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="statistics.userTotal ? statistics.userTotal : 0"
              :duration="3000"
            ></countTo
          ></span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon2.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text3") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="
                statistics.ridingDistance ? statistics.ridingDistance : 0
              "
              :duration="3000"
            ></countTo>
          </span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon3.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text4") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="
                statistics.ridingActivity ? statistics.ridingActivity : 0
              "
              :duration="3000"
            ></countTo>
            %</span
          >
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon4.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text5") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="
                statistics.carbonEmission ? statistics.carbonEmission : 0
              "
              :duration="3000"
            ></countTo>
          </span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon5.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 地图分布以及新增图表 -->
    <div class="distribution-add">
      <div class="distribution module">
        <div class="module-header">
          <div class="title">{{ $t("pages.statistics.text20") }}</div>
        </div>
        <div class="distribution-content">
          <div id="distribution-map"></div>
        </div>
      </div>
      <div class="add module">
        <div class="module-header">
          <div class="title">{{ $t("pages.statistics.text12") }}</div>
          <div class="header-region">
            <span class="el-dropdown-link" v-if="searchUser == '1'">
              {{ $t("pages.statistics.text13") }}
            </span>
            <span class="el-dropdown-link" v-if="searchUser == '2'">
              {{ $t("pages.statistics.text14") }}
            </span>
            <span class="el-dropdown-link" v-if="searchUser == '3'">
              {{ $t("pages.statistics.text18") }}
            </span>
            <el-dropdown @command="searchUserMethod">
              <span class="el-dropdown-link">
                <!--  {{ $t("afterSales.text34")
                }} --><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">
                  {{ $t("pages.statistics.text13") }}</el-dropdown-item
                >
                <el-dropdown-item command="2">
                  {{ $t("pages.statistics.text14") }}</el-dropdown-item
                >
                <el-dropdown-item command="3">
                  {{ $t("pages.statistics.text18") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="add-content">
          <div id="add-user-echarts"></div>
        </div>
      </div>
    </div>

    <!-- 骑行里程趋势 -->
    <div class="riding-mileage module">
      <div class="module-header">
        <div class="title">{{ $t("pages.statistics.text16") }}</div>
        <div class="header-region">
          <span class="el-dropdown-link" v-if="searchRiding == '7'">
            {{ $t("pages.statistics.text17") }}
          </span>
          <span class="el-dropdown-link" v-if="searchRiding == '14'">
            {{ $t("pages.statistics.text18") }}
          </span>
          <span class="el-dropdown-link" v-if="searchRiding == '30'">
            {{ $t("pages.statistics.text15") }}
          </span>
          <el-dropdown @command="searchRidingMethod">
            <span class="el-dropdown-link">
              <!--  {{ $t("afterSales.text34")
              }} --><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="7">{{
                $t("pages.statistics.text17")
              }}</el-dropdown-item>
              <el-dropdown-item command="14">
                {{ $t("pages.statistics.text18") }}</el-dropdown-item
              >
              <el-dropdown-item command="30">{{
                $t("pages.statistics.text15")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="add-content">
        <div id="ridin-echarts"></div>
      </div>
    </div>
    <!-- 骑行活跃趋势 -->
    <div class="riding-mileage module">
      <div class="module-header">
        <div class="title">{{ $t("pages.statistics.text19") }}</div>
        <div class="header-region">
          <span class="el-dropdown-link" v-if="searchCycling == '7'">
            {{ $t("pages.statistics.text17") }}
          </span>
          <span class="el-dropdown-link" v-if="searchCycling == '14'">
            {{ $t("pages.statistics.text18") }}
          </span>
          <span class="el-dropdown-link" v-if="searchCycling == '30'">
            {{ $t("pages.statistics.text15") }}
          </span>
          <el-dropdown @command="searchCyclingMethod">
            <span class="el-dropdown-link">
              <!--  {{ $t("afterSales.text34")
              }} --><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="7">
                {{ $t("pages.statistics.text17") }}</el-dropdown-item
              >
              <el-dropdown-item command="14">
                {{ $t("pages.statistics.text18") }}</el-dropdown-item
              >
              <el-dropdown-item command="30">{{
                $t("pages.statistics.text15")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="add-content">
        <div id="active-echarts"></div>
      </div>
    </div>
  </div>
</template>


<script>
import DiluEcharts from "../../components/pubilc/dilu-echarts.vue";
import * as echarts from "echarts";
import countTo from "vue-count-to";
import { mapState } from "vuex";
import remoteLoad from "@/assets/js/remoteLoad.js";
export default {
  data() {
    return {
      searchUser: "3", //新增用户搜索条件
      searchRiding: "30", //骑行里程条件
      searchCycling: "30", //骑行活跃条件
      map: null,
      center: [116.402921, 39.908177],
      statistics: {}, //统计数据
      mapList: [], //地图数据
    };
  },
  mounted() {
    this.getDataStatistics();
    this.bikeLocationData();
    this.appUserRegisterData();
    this.getRidingMileage();
    this.getRidingActiveCycling();
  },
  components: {
    DiluEcharts,
    countTo,
  },
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  methods: {
    //骑行活跃
    searchCyclingMethod(e) {
      this.searchCycling = e;
      this.getRidingActiveCycling();
    },
    //骑行里程
    searchRidingMethod(e) {
      this.searchRiding = e;
      this.getRidingMileage();
    },
    //用户搜索条件
    searchUserMethod(e) {
      this.searchUser = e;
      this.appUserRegisterData();
    },

    //统计数据
    getDataStatistics() {
      this.request.getDataStatistics().then((res) => {
        this.statistics = res.data;
      });
    },

    //车辆分布
    bikeLocationData() {
      this.request.bikeLocationData().then((res) => {
        let arr = res.data;
        let arr1 = [];
        for (let i in arr) {
          arr1.push([
            arr[i].location.split(",")[1],
            arr[i].location.split(",")[0],
          ]);
        }
        this.mapList = arr1;
        if (window.AMap&&window.AMapUI) {
          this.initAmap();
          // 未载入谷歌地图API，则先载入API再初始化
        } else {
          // 载入高德地图和UI组件
          Promise.all([
            remoteLoad(
              "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
            ),
          ]).then(() => {
            this.initAmap();
          });
        }
      });
    },

    // 查询平台方的新增用户注册图表信息
    appUserRegisterData() {
      let str = "?queryType=" + this.searchUser;
      this.request.appUserRegisterData(str).then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].appUserNum);
          y.push(res.data[i].date);
        }
        this.initAddUserEcharts(x, y);
      });
    },

    //骑行里程统计图
    getRidingMileage() {
      let str = "?dayTime=" + this.searchRiding;
      this.request.getRidingMileage(str).then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].oneDay);
          y.push(res.data[i].ridingMileage);
        }
        this.initRidinEcharts(x, y);
      });
    },

    //骑行活跃统计
    getRidingActiveCycling() {
      let str = "?dayTime=" + this.searchCycling;
      this.request.getRidingActiveCycling(str).then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].oneDay);
          y.push(res.data[i].ridingActivity);
        }
        this.initActiveEcharts(x, y);
      });
    },

    //高德地图
    initAmap() {
      let that = this;
      let positions = that.mapList;
      let center = [];
      if (positions.length < 1) {
        center = [116.394681, 39.900802];
      } else {
        center = [Number(positions[positions.length-1][0]), Number(positions[positions.length-1][1])];
      }
      var map = new AMap.Map("distribution-map",{
        zoom: 0,
        center: center,
        showLabel: true,
        expandZoomRange: true,
        pitch: 30,
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080",
      });
      map.on("complete", function () {
        let arr = [];
        for (var i = 0; i < positions.length; i++) {
          var curPosition = positions[i];
          arr[i] = new AMap.CircleMarker({
            center: curPosition,
            radius: 3 + Math.random() * 3, //3D视图下，CircleMarker半径不要超过64px
            strokeColor: "transparent",
            strokeWeight: 1,
            fillColor: "#1F5BCC",
            fillOpacity: 0.5,
            zIndex: 10,
            bubble: true,
            cursor: "pointer",
            clickable: true,
          });
          arr[i].setMap(map);
        }
      });
    },

    //初始化新增用户图表
    initAddUserEcharts(x, y) {
      var chartDom = document.getElementById("add-user-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        xAxis: {
          type: "category",
          data: y,
        },
        yAxis: {
          type: "value",
          max: "dataMax",
          splitNumber: 5,
          minInterval: 1,
        },
        series: [
          {
            data: x,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#2378f7" },
                { offset: 0.7, color: "#2378f7" },
                { offset: 1, color: "#83bff6" },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" },
                ]),
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //骑行里程趋势
    initRidinEcharts(x, y) {
      var chartDom = document.getElementById("ridin-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      let date = x;
      let data = y;
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          max: "dataMax",
          splitNumber: 5,
          minInterval: 1,
        },
        series: [
          {
            type: "line",
            smooth: 0.6,
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(31, 91, 204, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1F5BCC",
                },
                {
                  offset: 1,
                  color: "rgba(45, 110, 232, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //骑行活跃趋势
    initActiveEcharts(x, y) {
      var chartDom = document.getElementById("active-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      let date = x;
      let data = y;
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          max: "dataMax",
          splitNumber: 5,
          minInterval: 1,
        },
        series: [
          {
            type: "line",
            smooth: 0.6,
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(239, 162, 43, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#EFA22B",
                },
                {
                  offset: 1,
                  color: "rgba(229, 148, 25, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>


<style scoped>
.statistics {
  padding: 25px 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.cumulative-ul {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.cumulative-li {
  width: calc(20% - 25px);
  height: 120px;
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 6px #f0f3fa;
  border-radius: 6px;
}
.cumulative-li-left {
  display: flex;
  flex-direction: column;
}
.cumulative-li-left span:first-child {
  font-size: 14px;
  font-weight: normal;
  color: #7685a9;
  margin-bottom: 12px;
}
.cumulative-li-left span:last-child {
  font-size: 28px;
  font-family: DIN;
  font-weight: bold;
  color: #000000;
}
.cumulative-li-right {
  width: 40px;
  flex-shrink: 0;
}
.cumulative-li-right img {
  width: 100%;
}
.distribution-add {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.distribution {
  width: calc(2 / 3 * 100% - 25px);
  height: 558px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  opacity: 1;
  border-radius: 6px;
  margin-right: 25px;
}
.add {
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  opacity: 1;
  border-radius: 6px;
}
.module {
  padding: 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.module .module-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
  padding: 0 10px;
}
.module .module-header .title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}
.distribution-content {
  flex: 1;
  padding: 0 10px;
  box-sizing: border-box;
}
#distribution-map {
  width: 100%;
  height: 100%;
}
.header-region {
  background: rgba(210, 222, 244, 0.35);
  border-radius: 15px;
  padding: 5px 20px;
  box-sizing: border-box;
}
.add-content {
  flex: 1;
}
.riding-mileage {
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  border-radius: 6px;
  margin-bottom: 25px;
  flex-shrink: 0;
}
#ridin-echarts {
  width: 100%;
  height: 100%;
}
#add-user-echarts {
  width: 100%;
  height: 100%;
}
#active-echarts {
  width: 100%;
  height: 100%;
}
</style>